<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Tax-Exempt Organizations
    </Heading>
    We have a substantial practice in the formation of nonprofit organizations
    and in qualifying their exempt status with the IRS and California FTB. We
    counsel our nonprofit clients on issues as diverse as complying with
    nonprofit set-asides, structuring to avoid private inurement, conduct of
    non-charitable activities, establishing for-profit subsidiaries, minimizing
    unrelated business taxable income, structuring and monitoring grant making
    procedures, and complying with California’s property tax exemption
    requirements. We work closely with large and small tax-exempt organizations
    resolve tax issues. Our clients include public charities, nonprofit
    associations, professional societies and private foundations. We help our
    clients draft organizational documents, negotiate contracts, obtain
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewTaxExempt" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
